export const prospectUserForm = [
  {
    type: "text",
    label: "Last name",
    name: "lastName",
    required: true,
  },
  {
    type: "text",
    label: "First name",
    name: "firstName",
    required: true,
  },
  {
    type: "text",
    label: "Phone number",
    name: "phoneNumber",
    required: true,
  },
  {
    type: "email",
    label: "E-mail",
    name: "email",
    required: true,
  },
  {
    type: "password",
    name: "password",
    required: true,
    span: 12,
    // separator: true,
  },
];

export const updateProspectUserForm = [
  {
    type: "text",
    label: "Last name",
    name: "lastName",
    required: true,
  },
  {
    type: "text",
    label: "First name",
    name: "firstName",
    required: true,
  },
  {
    type: "text",
    label: "Phone number",
    name: "phoneNumber",
    required: true,
  },
  {
    type: "email",
    label: "E-mail",
    name: "email",
    required: true,
  },
  {
    type: "password",
    name: "password",
    required: true,
    span: 12,
    // separator: true,
  },
];
